import { Message, MessageBox } from 'element-ui'
import { extend } from 'sk-ui/lib/utils/util.js'

import npsStrategyForm from './metaData/npsStrategyForm'

import { clearLog } from '@/api/nps'
import lang from '@/lang'
export default {
  RelationTool({ commit }, props) {
    import('./metaData/relationTool').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData.default)
      metaDataCopy.view.columns[0] = {
        props: {
          type: 'radio',
          width: 55
        }
      }
      props.params = {
        toolStatus: 'ON_SHELF'
      }
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props, clone: false })
    })
  },
  NpsStrategyCreate({ commit }, params) {
    const props = {}
    const npsStrategyFormCopy = extend(true, {}, npsStrategyForm)
    this.dispatch('OpenFullDialog', {
      metaData: npsStrategyFormCopy,
      props
    })
  },
  NpsStrategyEdit({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      }
    }
    const npsStrategyFormCopy = extend(true, {}, npsStrategyForm)
    npsStrategyFormCopy.needFetchFillInfo = true
    this.dispatch('OpenFullDialog', {
      metaData: npsStrategyFormCopy,
      props
    })
  },
  NpsStrategyClear({ commit }, params) {
    if (!params.rowIds || params.rowIds.length === 0) {
      Message.error('请至少选择一个工具')
      return
    }
    MessageBox.confirm('确认重新开启所选工具的NPS采集吗？', lang.t('sk.tip'), {
      confirmButtonText: lang.t('confirm'),
      cancelButtonText: lang.t('cancel'),
      type: 'warning'
    }).then(({ value }) => {
      let toolIdList = []
      params.rows.forEach(el => {
        toolIdList.push(el.toolId)
      })
      const data = { toolIdList: toolIdList }
      clearLog(data).then(response => {
        this.dispatch('OpenNotification', {
          message: '重新开启所选NPS采集成功',
          type: 'success'
        })
        params.viewController.fetch()
      })
    })
  }
}
